import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseService, SettingsService, StorageService } from '../services';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomeGuard  {
  constructor(private router: Router,private baseService: BaseService,
              private storageService:StorageService, private settingsService: SettingsService) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const uId = this.storageService.getLocalStore('u_id');
    const profileId = this.storageService.getSessionStore('profileId');
    if((environment.appName === 'filmbox' || environment.appName === 'film1') && (this.baseService.showAndroidApp || this.baseService.showIosApp) && !uId){
      this.router.navigate(['/auth/signup'])
    } else if (this.settingsService?.maxUserProfiles > 0 && !profileId && uId) {
        this.router.navigate(['auth/user-profiles']);
    } else {
      return true;      
    }
  }
  
}
